import { render, staticRenderFns } from "./activitythememanage.vue?vue&type=template&id=6fbc2b56&scoped=true&"
import script from "./activitythememanage.vue?vue&type=script&lang=js&"
export * from "./activitythememanage.vue?vue&type=script&lang=js&"
import style0 from "./activitythememanage.vue?vue&type=style&index=0&id=6fbc2b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbc2b56",
  null
  
)

export default component.exports